import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

function RouteErrorFallback() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#050505] px-4">
      <div className="max-w-md w-full rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950 p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-2">
          {t('errors.route_title', 'Something went wrong')}
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          {t(
            'errors.route_body',
            'We hit an unexpected error loading this page. Our team has been notified.',
          )}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center rounded-md bg-emerald-500 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
        >
          {t('errors.reload', 'Reload page')}
        </button>
      </div>
    </div>
  );
}

export function RouteErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<RouteErrorFallback />} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
